import cx from 'classnames';
import { brandLogo, brandLogoSecondary, portalHomeUrl, } from '../utils/constants';
export function Logo({ className }) {
    return (<a href={portalHomeUrl} target="_blank" rel="noopener noreferrer" className={cx('nav-logo', className)} aria-label="City of Torrance Animal Control Portal">
      <img src={brandLogo} className="nav-logo-img" alt="City of Torrance"/>
      <img src={brandLogoSecondary} className="nav-logo-img nav-logo-img-secondary" alt="Animal Control Portal"/>
    </a>);
}
